<div class="flex-fill d-flex flex-column">
  @if (entities) {
    <div class="m-1 grid-fill">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        [dataSource]="entities"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-column dataField="level" caption="Level"></dxi-column>
        <dxi-column dataField="logged" caption="Created" format="shortDateShortTime"></dxi-column>
        <dxi-column dataField="message" caption="Message"></dxi-column>
        <dxi-column dataField="userName" caption="Username"></dxi-column>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="login-list-grid"></dxo-state-storing>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <!-- <button class="btn btn-secondary" (click)="open()" [disabled]="true">New</button>
          <button class="btn btn-success ms-2" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="true">Edit</button>
          <button class="btn btn-sm btn-warning ms-2" (click)="toggleShowAll()">{{ showAll ? 'Hide Inactive' : 'Show All' }}</button> -->
        </div>
      </dx-data-grid>
    </div>
  }
</div>
